<template>
    <div class="flat-index" id="wrapper">
        <div class="fi-pc cooperate-container">
            <div class="fi-main">
                <fi-header></fi-header>
                <div class="cooperate">
                    <div class="dd-icon"></div>
                    <div class="cooperate-list">
                        <div class="bew clearfix">
                            <div class="item">
                                <div class="name">
                                    <h2>姓名</h2>
                                    <span>Name</span>
                                </div>
                                <div class="enter">
                                    <input v-model="name" placeholder="" type="text" name="" value="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="name">
                                    <h2>公司</h2>
                                    <span>ITD</span>
                                </div>
                                <div class="enter">
                                    <input v-model="companyName" placeholder="" type="text" name="" value="">
                                </div>
                            </div>
                        </div>
                        <div class="bew clearfix">
                            <div class="item">
                                <div class="name">
                                    <h2>电话</h2>
                                    <span>Call</span>
                                </div>
                                <div class="enter">
                                    <input v-model="phone" placeholder="" type="text" name="" value="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="name">
                                    <h2>邮箱</h2>
                                    <span>E-mail</span>
                                </div>
                                <div class="enter">
                                    <input v-model="email" placeholder="" type="text">
                                </div>
                            </div>
                        </div>
                        <div class="bew clearfix">
                            <div class="item brief">
                                <div class="name">
                                    <h2>描述</h2>
                                    <span>Brief</span>
                                </div>
                                <div class="enter">
                                    <input v-model="description" placeholder="" type="text">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flat-btn" @click="sendHandle"><span>发送</span><i></i></div>
                </div>
            </div>
            <fi-footer></fi-footer>
        </div>
    </div>
</template>
<script>
import {
    os
} from '../utils/tool'
import FiHeader from '../components/header'
import FiFooter from '../components/footer'
import api from '../api/axios'

export default {
    components: {
        FiHeader,
        FiFooter
    },
    data() {
        const _vue = this;
        return {
            helpList: 4,
            activeArr: [],
            cfNum: -1,
            name: '',
            companyName: '',
            phone: '',
            email: '',
            description: ''
        }
    },
    created() {
        document.title = '商务合作';
    },
    mounted() {

    },
    methods: {
        clickHelpListHandle(index) {
            if (this.cfNum1 != index) {
                this.activeArr = []
                this.activeArr[index] = true
                this.cfNum1 = index
            } else {
                this.activeArr = []
                this.activeArr[this.cfNum1] = false
                this.cfNum1 = -1
            }
        },
        sendHandle() {
            if (this.name.trim()=='') {
                this.$toast({msg:'请输入您的名称'})
                return
            }
            if (this.companyName.trim()=='') {
                this.$toast({msg:'请输入您的公司'})
                return
            }
            if (this.phone.trim()=='') {
                this.$toast({msg:'请输入您的电话'})
                return
            }
            if (this.email.trim()=='') {
                this.$toast({msg:'请输入您的邮箱'})
                return
            }
            if (this.description.trim()=='') {
                this.$toast({msg:'请输入您的描述问题'})
                return
            }
            this.$loading()
            api.axios({
                id: 'officialWebsiteAPI.sendEmail',
                param: {
                    name: this.name,
                    companyName: this.companyName,
                    phone: this.phone,
                    email: this.email,
                    description: this.description,
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo,
                }
            }).then((res) => {
                this.$loading.end()
                var data = res.data
                if (data.status == "SUCCESS") {
                    //成功
                    console.log(data,'data');
                    this.$toast({ msg: '提交成功' })
                    this.name=''
                    this.companyName=''
                    this.phone=''
                    this.email=''
                    this.description=''
                } else {
                    if(data.code=="2200"){
                        this.$toast({ msg:'登录信息超时，请重新登录'})
                        this.$storage.init()
                        setTimeout(()=>{
                            window.location.reload()
                        },300)
                        return
                    }
                    this.$toast({ msg: data.message })
                }
            }).catch((error) => {
                this.$loading.end()
                this.$toast({ msg: error.message })
            })
        }

    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Cooperate.vue?69014081